import { render, staticRenderFns } from "./coupon.vue?vue&type=template&id=bebfec74&scoped=true&"
import script from "./coupon.vue?vue&type=script&lang=js&"
export * from "./coupon.vue?vue&type=script&lang=js&"
import style0 from "./coupon.vue?vue&type=style&index=0&id=bebfec74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bebfec74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bebfec74')) {
      api.createRecord('bebfec74', component.options)
    } else {
      api.reload('bebfec74', component.options)
    }
    module.hot.accept("./coupon.vue?vue&type=template&id=bebfec74&scoped=true&", function () {
      api.rerender('bebfec74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/pro/field-template/coupon.vue"
export default component.exports